<template>
    <div class="container">
        <div id="app">
            <div>
                <h3 class="text-center mt-3 mb-3">Imagens da vistoria</h3>
                <div class="mb-3" v-for="foto in imgs" v-bind:key="foto">
                    <img :src="foto.image_base64" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Database from "@/controller/database";
export default {
    name: "Imagens",
    data: function () {
        return {
            imgs: [],
        };
    },
    created() {
        const id = this.idVistoria;
        const vm = this;
        const db = new Database();
        db.createOrOpenDatabase({ pegarImagens: true }, parseInt(id)).then((imagens) => {
            vm.imgs = imagens;
        });
    },
    computed: {
        idVistoria: function () {
            return this.$route.query.id;
        },
    },
};
</script>
<style scoped>
#app {
    height: 100%;
    font-family: "Roboto";
    font-style: normal;
    color: black;
}
</style>
